(function() {
  var $cfcc232893745887$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("blog-tabs")) customElements.define("blog-tabs", class BlogTabs extends HTMLElement {
      constructor() {
        super();
        this._onTabClick = this._onTabClick.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
      }
      connectedCallback() {
        this._initializeTabs();
        this.addEventListener("click", this._onTabClick);
        this.addEventListener("keydown", this._onKeyDown);
      }
      _initializeTabs() {
        const tabs = this.querySelectorAll('[role="tab"]');
        let foundFirst = false;
        for (const tab of tabs) {
          const panelId = tab.getAttribute("aria-controls");
          const panel = this.querySelector(`#${panelId}`);
          const hasContent = panel?.querySelector(".blog-rte")?.innerText.trim().length > 0;
          if (!foundFirst && hasContent) {
            tab.setAttribute("aria-selected", "true");
            tab.tabIndex = 0;
            panel?.classList.remove("hidden");
            foundFirst = true;
          } else {
            tab.setAttribute("aria-selected", "false");
            tab.tabIndex = -1;
            panel?.classList.add("hidden");
          }
        }
        if (!foundFirst && tabs.length > 0) {
          const firstTab = tabs[0];
          const firstPanelId = firstTab.getAttribute("aria-controls");
          const firstPanel = this.querySelector(`#${firstPanelId}`);
          firstTab.setAttribute("aria-selected", "true");
          firstTab.tabIndex = 0;
          firstPanel?.classList.remove("hidden");
        }
      }
      _getTabs() {
        return [ ...this.querySelectorAll('[role="tab"]') ];
      }
      async _activateTab(tab) {
        const currentTab = this.querySelector('[role="tab"][aria-selected="true"]');
        if (tab === currentTab) return;
        const currentPanelId = currentTab?.getAttribute("aria-controls");
        const currentPanel = currentPanelId ? this.querySelector(`#${currentPanelId}`) : null;
        const nextPanelId = tab.getAttribute("aria-controls");
        const nextPanel = this.querySelector(`#${nextPanelId}`);
        this._getTabs().forEach(t => {
          const isSelected = t === tab;
          t.setAttribute("aria-selected", isSelected ? "true" : "false");
          t.tabIndex = isSelected ? 0 : -1;
        });
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (currentPanel) {
          if (!reducedMotion) await currentPanel.animate([ {
            opacity: 1,
            transform: "translateY(0)"
          }, {
            opacity: 0,
            transform: "translateY(4px)"
          } ], {
            duration: 200,
            easing: "ease-out"
          }).finished;
          currentPanel.classList.add("hidden");
        }
        if (nextPanel) {
          nextPanel.classList.remove("hidden");
          if (!reducedMotion) nextPanel.animate([ {
            opacity: 0,
            transform: "translateY(4px)"
          }, {
            opacity: 1,
            transform: "translateY(0)"
          } ], {
            duration: 300,
            easing: "ease-in",
            fill: "both"
          });
        }
      }
      async _onTabClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        event.preventDefault();
        await this._activateTab(tab);
      }
      _onKeyDown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const tabs = this._getTabs();
        const currentIndex = tabs.indexOf(tab);
        let targetIndex = -1;
        if (event.key === "ArrowRight") targetIndex = (currentIndex + 1) % tabs.length; else if (event.key === "ArrowLeft") targetIndex = (currentIndex - 1 + tabs.length) % tabs.length; else if (event.key === "Home") targetIndex = 0; else if (event.key === "End") targetIndex = tabs.length - 1; else return;
        event.preventDefault();
        tabs[targetIndex].focus();
        this._activateTab(tabs[targetIndex]);
      }
    });
  })();
})();